import { useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import querystring from "query-string";
import {
  ServerAwareUpdateTempViewsContext,
  ServerAwareViewsContext
} from "../CGrid/ServerAwareViews";
import { useSpace } from "../../Contexts/SpaceContext";
import { ServerAwareFavoritesContext } from "../../Containers/AppBar/ServerAwareFavorite";
export const CardChooserListnerDict = {};

const calculateColumns = (columns, orderList = []) => {
  const fieldDict = getfieldTitleDict(columns);
  const result = [];
  for (const c of orderList) {
    if (fieldDict[c]) result.push(fieldDict[c]);
  }

  return result;
};

const getfieldTitleDict = (Columns) => {
  const result = {};
  for (const c of Columns) {
    result[c.title] = c;
  }
  return result;
};

export const useResolvedCards = (columns, id) => {
  const favoriteResult = useResolvedFavoriteCards(columns);
  const viewsResult = useResolvedViewCards(columns, id);
  if (favoriteResult) return favoriteResult;
  else return viewsResult;
};

const useResolvedFavoriteCards = (columns) => {
  const FavoriteItem = useContext(ServerAwareFavoritesContext);
  if (!FavoriteItem) return null;
  const { cardLayout } = FavoriteItem.data;
  return calculateColumns(columns, cardLayout);
};

const useResolvedViewCards = (columns, id) => {
  const location = useLocation();
  const space = useSpace();
  const { search } = location;
  const queryObj = querystring.parse(search);
  const { viewPref } = queryObj;
  const lsViews = useContext(ServerAwareViewsContext);
  const updateLsViews = useContext(ServerAwareUpdateTempViewsContext);
  const index = lsViews?.findIndex((e) => e.id === viewPref);

  const orderList = useMemo(() => {
    if (index !== -1 && lsViews) {
      return lsViews[index]?.cardLayout || [];
    } else if (lsViews) {
      return lsViews[0]?.cardLayout || [];
    } else return [];
  }, [index, lsViews]);

  const resolvedColumn = useMemo(
    () => calculateColumns(columns, orderList),
    [columns, orderList]
  );

  const updateLocalStorage = useCallback(
    (columns) => {
      let gridSavedViews = JSON.parse(
        window.localStorage.getItem(`ar-grid-saved-views-space-${space.Id}`)
      );
      const viewGridViews = gridSavedViews[id];
      const index = viewGridViews.findIndex((e) => e.id === viewPref);
      let resolvedIndex = index === -1 ? 0 : index;
      let viewGridObject = viewGridViews[resolvedIndex] || {};
      viewGridObject.cardLayout = columns;
      viewGridViews[resolvedIndex] = viewGridObject;
      gridSavedViews[id] = viewGridViews;
      localStorage.setItem(
        `ar-grid-saved-views-space-${space.Id}`,
        JSON.stringify(gridSavedViews)
      );
      updateLsViews();
    },
    [id, space.Id, updateLsViews, viewPref]
  );

  useEffect(() => {
    if (!CardChooserListnerDict[id]) CardChooserListnerDict[id] = [];

    const listner = (orderList) => {
      //;
      if (!orderList) updateLocalStorage(columns);
      else updateLocalStorage(calculateColumns(columns, orderList));
    };

    CardChooserListnerDict[id].push(listner);

    return () => {
      const index = CardChooserListnerDict[id].indexOf(listner);
      CardChooserListnerDict[id].splice(index, 1);
    };
  }, [columns, id, updateLocalStorage]);

  return resolvedColumn;
};
